import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteConfirmationModal from "../../../components/commonComponent/DeleteConfirmationModal";
import Pagination from "../../../components/commonComponent/Pagination";
import Search from "../../../components/commonComponent/Search";
import Table from "../../../components/commonComponent/Table";
import ViewModal from "../../../components/commonComponent/ViewModal";
import useModal from "../../../hooks/useModal";
import "../../../styles/SolarStation.css";
import { deleteData } from "../../../utils/utils";
import useLoader from "../../../hooks/useLoader";

const API_URL = process.env.REACT_APP_API_URL;


const columns = [
    { header: "Title", accessor: "title" },
    { header: "Date", accessor: "date" },
    { header: "Time", accessor: "time" },
    { header: "Views", accessor: "views" },
    // { header: "Video URL", accessor: "video" },
];

const ITEMS_PER_PAGE = 10;

const Videos = () => {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { loading, showLoader, hideLoader } = useLoader();

    const {
        showDeleteModal,
        showViewModal,
        selectedItem,
        handleOpenDeleteModal,
        handleCloseDeleteModal,
        handleOpenViewModal,
        handleCloseViewModal,
    } = useModal();

    const fetchVideos = async () => {
        try {
            showLoader();
            const response = await fetch(
                `${API_URL}/video/getAllVideos?page=${currentPage}&limit=${ITEMS_PER_PAGE}&search=${searchTerm}`
            );
            const result = await response.json();

            if (response.ok) {
                console.log("Fetched video data:", result);
                setData(result.videos || []); // Update this line
                setTotalPages(result.totalPages); // Ensure this line is correct
            } else {
                setError(result.error || "Failed to fetch videos");
                toast.error(result.error || "Failed to fetch videos");
            }
        } catch (error) {
            setError("Failed to fetch data");
            toast.error("Failed to fetch data");
        } finally {
            hideLoader();
        }
    };

    useEffect(() => {
        fetchVideos();
    }, [currentPage, searchTerm]);

    const handleSearch = (term) => {
        if (term.length >= 2 || term.length === 0) {
            setSearchTerm(term);
            setCurrentPage(1);
        }
    };

    const handleDeleteConfirm = () => {
        deleteData(`${API_URL}/video/deleteVideo`, selectedItem._id, setError)
            .then(() => {
                setData((prevData) =>
                    prevData.filter((item) => item._id !== selectedItem._id)
                );
                toast.success("Deleted successfully");
                fetchVideos(); // Refresh the videos list after deletion
            })
            .catch((error) => {
                setError(error);
                toast.error("Error deleting data");
            });
        handleCloseDeleteModal();
    };

    const fieldsToShow = {
        Title: "title",
        Date: "date",
        Time: "time",
        Views: "views",
        "Video URL": "video",
    };

    return (
        <div>
            <h2 className="capitalize font-bold text-[24px] mb-4">Videos List</h2>

            <div className="flex justify-between items-center shadow-md px-8 py-[10px] rounded-md bg-[#fff] text-base mb-4">
                <Search
                    searchFields={["Title", "Date", "Views"]}
                    onSearch={handleSearch}
                />
                <Link
                    to="/videos/add"
                    className="inline-flex items-center justify-center rounded-md border border-white px-4 py-1.5 text-center font-medium text-white bg-[#1C2434] hover:bg-opacity-90"
                >
                    Add Video
                </Link>
            </div>

            <Table
            
                columns={columns}
                data={data}
                showIndex={true}
                onDelete={handleOpenDeleteModal}
                onUpdate={(item) => navigate(`/videos/edit/${item._id}`)}
                onView={handleOpenViewModal}
                actions={{
                    showView: true,
                    showEdit: true,
                    showDelete: true,
                }}
                loading={loading}
            />
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
            />

            <DeleteConfirmationModal
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onConfirm={handleDeleteConfirm}
            />

            <ViewModal
                show={showViewModal}
                onHide={handleCloseViewModal}
                data={selectedItem}
                fields={fieldsToShow}
            />
        </div>
    );
};

export default Videos;
